import { withTheme } from '@material-ui/styles';
import MaterialTable, { MaterialTableProps, Options } from 'material-table';
import React from 'react';

interface ISimpleTable extends Options, MaterialTableProps {
    actions: any[];
    options: Options;
    theme: any;
    id: string;
}

const SimpleTable = ({
    actions,
    columns,
    data,
    id,
    onChangeRowsPerPage,
    onRowClick,
    onSelectionChange,
    options,
    theme,
}: ISimpleTable) => {
    const { palette } = theme;


    return (
        <MaterialTable
            actions={actions}
            columns={columns}
            data={data}
            onChangeRowsPerPage={onChangeRowsPerPage}
            onRowClick={onRowClick}
            onSelectionChange={onSelectionChange}
            options={{
                sorting:true,
                debounceInterval:500,
                emptyRowsWhenPaging: false,
                searchFieldAlignment: 'left',
                headerStyle: {
                    backgroundColor: palette.primary.main,
                    color: palette.common.white,
                },
                ...options,
            }}
            style={{ width: '100%', boxShadow: 'none', minHeight: '50vh' }}
            title=""
        />
    );
};

export default withTheme(SimpleTable);
